const ID = ':id';

export const PHYSICAL_TRANSPORT_P = 'physical-transport';
export const PHYSICAL_TRANSPORT_PF = `/${PHYSICAL_TRANSPORT_P}`;

export const JOURNEYS_P = 'journeys';
export const JOURNEYS_PF = `${PHYSICAL_TRANSPORT_PF}/${JOURNEYS_P}`;
export const JOURNEY_ID_P = `journey-detail/${ID}`;
export const JOURNEY_ID_PF = `${PHYSICAL_TRANSPORT_PF}/${JOURNEY_ID_P}`;

export const SEARCH_P = 'search';
export const SEARCH_PF = `${PHYSICAL_TRANSPORT_PF}/${SEARCH_P}`;

export const REPORT_P = 'report';
export const REPORT_PF = `${PHYSICAL_TRANSPORT_PF}/${REPORT_P}`;

export const REPORT_MASTER_P = 'report-master';
export const REPORT_MASTER_PF = `${PHYSICAL_TRANSPORT_PF}/${REPORT_MASTER_P}`